<template>
  <section class="home-process-container">
    <h2 class="home-title">서비스 운영 프로세스</h2>
    <p class="home-sub-title">
      주문부터 수집 완료까지 평균 1~2일이 걸려요. 지금 어느 단계인지 마이페이지에서 같은 순서로 보여드려요.
    </p>

    <div class="process-grid">
      <div class="process-card" :class="{ 'process-card--active': idx === 0 }" v-for="(step, idx) in steps" :key="idx">
        <div class="process-card-top">
          <span class="process-step">STEP {{ idx + 1 }}</span>
          <span class="process-role">{{ step.role }}</span>
        </div>
        <div class="process-title">{{ step.title }}</div>
        <div class="process-duration">{{ step.duration }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeProcess',

  data() {
    return {
      steps: [
        { role: '리서처', title: '설문 응답 서비스 주문 완료', duration: '3분' },
        { role: '서베이지', title: '설문 검수 후, 패널에게 설문 전달', duration: '~3시간' },
        { role: '패널', title: '설문 응답', duration: '평균 18시간' },
        { role: '서베이지', title: '불량 응답 검수', duration: '~3시간' },
        { role: '리서처', title: '설문 응답 수집 완료', duration: '1~2일' }
      ]
    }
  }
}
</script>

<style scoped>
.home-process-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.home-title {
  margin: 0 0 var(--space-3) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.home-sub-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 17px;
  color: var(--text-muted);
  text-align: left;
  line-height: 1.6;
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.process-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-6);
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-lg);
  text-align: left;
  box-sizing: border-box;
}

.process-card--active {
  background-color: var(--green-50);
  border-color: var(--green-300);
}

.process-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.process-step {
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
}

.process-role {
  padding: 2px 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--ink-200);
  font-size: 11px;
  color: var(--text-muted);
  white-space: nowrap;
}

.process-card--active .process-role {
  border-color: var(--green-300);
  color: var(--green-600);
}

.process-title {
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-heading);
  line-height: 1.4;
}

.process-duration {
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--green-600);
}

@media (max-width: 900px) {
  .process-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }

  .process-grid {
    grid-template-columns: 1fr;
  }
}
</style>
